import { formatItemValue, measureLabels } from "./format.js";
import { emojiGrid } from "./game.js";
import { interpolate } from "./strings.js";

export function renderModal(root, state, handlers) {
  root.textContent = "";
  const strings = state.strings;
  const overlay = document.createElement("div");
  overlay.className = "wq-overlay";
  overlay.addEventListener("click", (event) => {
    if (event.target === overlay) handlers.minimize();
  });
  const dialog = document.createElement("section");
  dialog.className = "wq-modal";
  dialog.setAttribute("role", "dialog");
  dialog.setAttribute("aria-modal", "true");
  dialog.setAttribute("aria-labelledby", "wq-title");

  const header = document.createElement("header");
  header.className = "wq-modal__header";
  const close = document.createElement("button");
  close.className = "wq-icon-button";
  close.type = "button";
  close.setAttribute("aria-label", strings.aria.minimize);
  close.textContent = "×";
  close.addEventListener("click", handlers.minimize);
  const hearts = document.createElement("div");
  hearts.className = "wq-hearts";
  hearts.setAttribute("aria-label", interpolate(strings.aria.lives, { count: state.game.lives }));
  for (let i = 0; i < 3; i += 1) {
    const heart = document.createElement("span");
    heart.className = i < state.game.lives ? "is-live" : "is-empty";
    heart.textContent = "♥";
    hearts.append(heart);
  }
  const streak = document.createElement("div");
  streak.className = "wq-streak";
  streak.textContent = interpolate(strings.modal.streak, { streak: state.game.streak });
  header.append(close, hearts, streak);

  const body = document.createElement("div");
  body.className = "wq-modal__body";
  if (state.game.gameOver) {
    renderGameOver(body, state, handlers);
  } else {
    renderRound(body, state, handlers);
  }
  dialog.append(header, body);
  overlay.append(dialog);
  root.append(overlay);
}

function renderRound(body, state, handlers) {
  const title = document.createElement("h2");
  title.id = "wq-title";
  title.className = "wq-sr-only";
  title.textContent = state.strings.aria.quiz;
  body.append(title);
  const baseline = state.game.reveal?.baseline || state.game.baseline;
  const strings = state.strings;
  const labels = measureLabels(baseline, strings);
  body.append(itemCard(baseline, formatItemValue(baseline, state.locale), strings.modal.baseline, false));
  const vs = document.createElement("div");
  vs.className = "wq-vs";
  vs.textContent = strings.modal.vs;
  body.append(vs);
  body.append(itemCard(
    state.game.challenge,
    state.game.reveal ? formatItemValue(state.game.challenge, state.locale) : "???",
    strings.modal.challenge,
    Boolean(state.game.reveal),
    state.game.reveal?.correct
  ));
  const prompt = document.createElement("p");
  prompt.className = "wq-modal-question";
  prompt.textContent = state.game.reveal
    ? (state.game.reveal.correct ? strings.reveal.right : interpolate(strings.reveal.wrong, { weight: formatItemValue(state.game.challenge, state.locale) }))
    : labels.question;
  if (state.game.reveal) prompt.classList.add(state.game.reveal.correct ? "is-right" : "is-wrong");
  body.append(prompt);
  if (state.game.reveal?.item.fact) {
    const fact = document.createElement("p");
    fact.className = "wq-fact";
    fact.textContent = state.game.reveal.item.fact;
    body.append(fact);
  }
  const actions = document.createElement("div");
  actions.className = "wq-actions wq-actions--modal";
  if (state.game.reveal) {
    const pending = document.createElement("p");
    pending.className = "wq-auto-next";
    pending.textContent = strings.modal.autoNext;
    actions.append(pending);
  } else {
    const heavier = document.createElement("button");
    heavier.type = "button";
    heavier.textContent = labels.up;
    heavier.addEventListener("click", () => handlers.answer("heavier"));
    const lighter = document.createElement("button");
    lighter.type = "button";
    lighter.textContent = labels.down;
    lighter.addEventListener("click", () => handlers.answer("lighter"));
    actions.append(heavier, lighter);
  }
  body.append(actions);
}

function renderGameOver(body, state, handlers) {
  const strings = state.strings;
  const title = document.createElement("h2");
  title.id = "wq-title";
  title.className = "wq-gameover-title";
  title.textContent = `🏋️ ${strings.gameover.title}`;
  const streak = document.createElement("p");
  streak.className = "wq-gameover-streak";
  streak.textContent = interpolate(strings.gameover.streak, { streak: state.game.streak });
  const grid = document.createElement("p");
  grid.className = "wq-emoji-grid";
  grid.textContent = emojiGrid(state.game.history, true);
  const share = document.createElement("button");
  share.className = "wq-primary";
  share.type = "button";
  share.textContent = strings.gameover.share;
  share.addEventListener("click", handlers.share);
  const again = document.createElement("button");
  again.type = "button";
  again.textContent = strings.gameover.playAgain;
  again.addEventListener("click", handlers.playAgain);
  const seeAll = document.createElement("a");
  seeAll.href = state.config.seeAllUrl;
  seeAll.textContent = strings.gameover.seeAll;
  seeAll.addEventListener("click", handlers.seeAll);
  body.classList.add("wq-gameover");
  body.append(title, streak, grid, share, again, seeAll);
}

function itemCard(item, weight, label, reveal = false, correct = false) {
  const card = document.createElement("article");
  card.className = "wq-item";
  if (reveal) card.classList.add(correct ? "is-right" : "is-wrong");
  const eyebrow = document.createElement("p");
  eyebrow.className = "wq-eyebrow";
  eyebrow.textContent = label;
  const emoji = document.createElement("div");
  emoji.className = "wq-emoji";
  emoji.textContent = item.emoji || "📦";
  const name = document.createElement("h3");
  name.textContent = item.name;
  const weightNode = document.createElement("p");
  weightNode.className = "wq-weight";
  weightNode.textContent = weight;
  card.append(eyebrow, emoji, name, weightNode);
  return card;
}
